import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import MasterPage from '../../components/master-page/MasterPage';
import { RootState } from '../../core/state/state';
import { isUserSubcontractor } from '../../core/state/user/selectors';
import { LOGIN_ROUTE, PROJECT_LISTING, PROFILE, COMPANY_CONTACTS, FORBIDDEN, NOTIFICATIONS_EMAIL, BARRIER_LOGS } from '../../core/constants/routes';
import { useAppAuth } from '../../core/hooks/useAppAuth';

interface Props {
  component: any;
  exact?: boolean;
  path: string;
}

export const PrivateRoute: React.FC<Props> = ({ component: Component, exact, path }) => {
  const { isAuthenticated, isLoading } = useAppAuth();
  const projectId = useSelector((state: RootState) => state.user.userInfo?.projectID);
  const isSubcontractor = useSelector(isUserSubcontractor);

  const getSubcontractorAllowedRoutes = () => [
    `${PROJECT_LISTING}/${projectId}/bookings`,
    `${PROJECT_LISTING}/${projectId}/bookings/calendar`,
    `${PROJECT_LISTING}/${projectId}/bookings/list`,
    `${PROJECT_LISTING}/${projectId}/documents`,
    PROFILE,
    COMPANY_CONTACTS,
    NOTIFICATIONS_EMAIL,
    BARRIER_LOGS
  ];

  return (
    <Route
      exact={exact}
      path={path}
      render={({ history, location, match, staticContext }) => {
        if (isLoading) {
          return null;
        }

        if (isAuthenticated) {
          if (isSubcontractor && !getSubcontractorAllowedRoutes().includes(location.pathname)) {
            return (
              <Redirect
                to={{
                  pathname: FORBIDDEN
                }}
              />
            );
          }
          return (
            <MasterPage>
              <Component history={history} location={location} match={match} staticContext={staticContext} />
            </MasterPage>
          );
        }
        return (
          <Redirect
            to={{
              pathname: LOGIN_ROUTE,
              state: { from: location }
            }}
          />
        );
      }}
    />
  );
};
